module.exports = __webpack_public_path__ + "img/20191218154708360截图20191218105639534.343b3911.jpg";